import { useFeed } from 'lead/application'
import React from 'react'
import { Error, MainLayout } from 'shared/ui'
import { useLeadById } from '../application/useLeadById.hook'
import { ErrorContainer, View } from './components/Lead.styles'
import { Lead } from './Lead'

const LeadContainer = () => {
  const { lead, error, loading } = useLeadById()
  const {
    feedItems,
    resolveFeedColor,
    handleDocumentRouterChange,
    setShowFade,
    showFade,
    mountFeedTitle,
  } = useFeed(lead)

  const mountName = currentLead => {
    const fullName = currentLead.borrower.fullName
    const firstName = fullName.split(' ')[0]
    const restOfName = fullName.substring(firstName.length, fullName.length)

    return (
      <>
        <span data-testid="lead-first-name">{firstName}</span> {restOfName}
      </>
    )
  }

  const leadProps = {
    mountName,
    lead,
    feed: {
      feedItems,
      mountFeedTitle,
      resolveFeedColor,
      handleDocumentRouterChange,
      setShowFade,
      showFade,
    },
  }

  return (
    <>
      <MainLayout hasPadding={false}>
        <View>
          {!error && !loading && <Lead {...leadProps} />}
          {error && !loading && (
            <ErrorContainer>
              <Error />
            </ErrorContainer>
          )}
        </View>
      </MainLayout>
    </>
  )
}

export { LeadContainer }
